export default "__VITE_ASSET__BGEXYvKO__";